// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gqnaN8RudTOdxw {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 8px;
}
.gqnaN8RudTOdxw:focus {
  outline: -webkit-focus-ring-color auto 5px;
}
@-moz-document url-prefix() {
  .gqnaN8RudTOdxw:focus {
    outline: black dotted 1px;
  }
}
.TScnIQPbkMQo_l {
  width: unset;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardLink": `gqnaN8RudTOdxw`,
	"boardCard": `TScnIQPbkMQo_l`
};
export default ___CSS_LOADER_EXPORT___;
